import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModule, Link, Text,
} from '@domain-group/suit-theme'

import useUsers from '@hooks/useUsers'

import SupportUserListItem from './components/SupportUserListItem'

interface SupportUsersListProps {
  onClick: () => void,
  userIds: number[],
}

const SupportUsersList = (props: SupportUsersListProps) => {
  const { onClick, userIds = [] } = props

  const usersPayload = useUsers({
    // @ts-expect-error TS2741
    filters: { user_ids: userIds },
    performHttpRequests: !!userIds.length,
    requestOptions: { include_image_sizes: true, include_user_image: true },
  })

  const {
    filteredUsers,
    hasFilteredUsers,
  } = usersPayload

  return (
    <DashboardModule
      title="Support Users"
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link
          greyLink
          onClick={() => onClick()}
          textProps={{ fontSize: 'medium', height: 'fit-content' }}
        >
          <FontAwesomeIcon icon={faPencil} />
        </Link>
    )}
    >
      <DashboardModule.ScrollableSection>
        {filteredUsers.map(user => <SupportUserListItem key={user.id} supportUserId={user.id} />)}
      </DashboardModule.ScrollableSection>

      {!hasFilteredUsers && (
        <Box padding="large">
          <Text
            color="bodyFontLightColor"
            fontSize="small"
            variant="ellipsis"
            maxWidth="60%"
          >
            Support Users Not Set
          </Text>
        </Box>
      )}
    </DashboardModule>
  )
}

export default SupportUsersList
